import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button';
import MoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { fg } from '@confluence/feature-gating';

import { LEARN_MORE_URL } from '../../constants.ts';

import { commonMessages } from './i18n.ts';

const i18n = defineMessages({
	// eslint-disable-next-line @atlassian/i18n/require-description
	dismiss: {
		id: 'storage-enforcement.banner.button.dismiss',
		defaultMessage: 'Dismiss',
	},
	moreIcon: {
		id: 'storage-enforcement.icons.more',
		defaultMessage: 'More icon',
		description: 'Accessibility label for a more icon',
	},
});

export const SiteAdminDropdownMenu = ({
	handleDismiss = () => {},
	showDismiss,
	onLearnMoreClick,
}: {
	handleDismiss?: () => void;
	showDismiss?: boolean;
	onLearnMoreClick: () => void;
}) => {
	const { formatMessage } = useIntl();

	return (
		<DropdownMenu
			trigger={({ triggerRef, ...props }) => (
				<Button
					{...props}
					appearance="subtle"
					iconBefore={<MoreIcon label={formatMessage(i18n.moreIcon)} />}
					ref={triggerRef}
				/>
			)}
			shouldRenderToParent={fg('should-render-to-parent-should-be-trueadmin-experi')}
		>
			<DropdownItemGroup>
				<DropdownItem href={LEARN_MORE_URL} target="_blank" onClick={onLearnMoreClick}>
					{formatMessage(commonMessages.learnMoreLink)}
				</DropdownItem>
				{showDismiss && (
					<DropdownItem onClick={handleDismiss}>{formatMessage(i18n.dismiss)}</DropdownItem>
				)}
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
